import { Alert } from '../../../components/Alert';
import { AlertProps } from '../../../components/Alert/Alert';
import InspectionIcon from '../../../assets/icons/inspection.svg?react';
import styles from './InspectionAlert.module.css';
import { LFC } from '../../../types';

interface InspectionAlertProps extends AlertProps {}

export const InspectionAlert: LFC<InspectionAlertProps> = ({
  open,
  onClose,
  children,
}) => (
  <Alert className={styles.alert} open={open} onClose={onClose}>
    <div className={styles.icon}>
      <InspectionIcon />
    </div>
    {children}
  </Alert>
);
